import {
  Form,
  Tab,
} from '@mairistem/composants';
import React from 'react';
import {
  LigneMouvement,
  Rib,
  Sens,
  Tiers,
} from '@mairistem/comptabilite';
import BaseProfilEcritureMouvement from
  '../../../../classes/mouvements/profilEcriture/Base/BaseProfilEcritureMouvement';
import { isLibelleReferenceVisible } from '../../../../constants/mouvements/modeReglements';
import getRibChanges from '../../../../utils/mouvements/rib';
import ReferencesBancaire from '../../Common/ReferencesBancaire';
import TiersInformations from '../../Common/TiersInformations';

interface LigneMouvementTiersProps {
  ligne: LigneMouvement;
  onChange: (data: Partial<LigneMouvement>) => void
  profilEcriture: BaseProfilEcritureMouvement;
  sens: Sens;
}

const LigneMouvementTiers = ({
  ligne,
  onChange,
  profilEcriture,
  sens,
}: LigneMouvementTiersProps) => {
  const [identifiantRib, setIdentifiantRib] = React.useState<number>();

  /**
   * Récupération de l'identifiant rib en fonction
   * de l'iban actuellement posé sur la ligne et la liste
   * des ribs du tiers
   */
  React.useEffect(() => {
    setIdentifiantRib(Number(ligne?.tiers?.ribs?.find((rib) => rib.iban === ligne?.iban)?.identifiant));
  }, [
    ligne?.iban,
    ligne?.tiers?.ribs,
  ]);

  const handleTiersChange = (tiers: Tiers) => {
    if (ligne?.tiers?.identifiant !== tiers?.identifiant) {
      onChange?.({
        identifiantTiers: Number(tiers?.identifiant),
        tiers,
      });
    }
  };

  const handleChange = (e, { name, value }) => onChange?.({ [name]: value });

  const handleRibChange = (rib: Rib) => onChange?.(getRibChanges(rib));

  return (
    <Tab.Pane as={Form}>
      <TiersInformations
        adresse={ligne?.tiers?.adresses?.[0]}
        modeReglement={ligne?.modeReglement}
        onChange={onChange}
        onReset={() => handleTiersChange({})}
        onTiersChange={handleTiersChange}
        profilEcriture={profilEcriture}
        sens={sens}
        tiers={ligne?.tiers}
      />
      {isLibelleReferenceVisible(ligne?.modeReglement, sens) && (
        <ReferencesBancaire
          identifiantRib={identifiantRib}
          identifiantTiers={ligne?.identifiantTiers}
          libelleVirementZoneLibre={ligne?.libelleVirementZoneLibre}
          libelleVirementZonLibre={ligne?.libelleVirementZonLibre}
          onChange={handleChange}
          onRibChange={handleRibChange}
          ribs={ligne?.tiers?.ribs}
        />
      )}
    </Tab.Pane>
  );
};

export default LigneMouvementTiers;
